import TaxFile from './TaxFile/index.vue'

export default [
  { path: '/tax/taxfile', component: TaxFile, meta: { auth: 'corp' } }
]